const forgotPasswordTranslations = {
  en: {
    pageTitle: "Forgot Password",
    heroTitle: "Forgot Password",
    heroDesc: "Reset your password",
    emailPlaceholder: "Enter your email",
    sendBtn: "Send Reset Link",
    sending: "Sending...",
    success:
      "If your email is registered, you will receive a password reset link.",
    error: "Failed to send reset link.",
  },
  pa: {
    pageTitle: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ",
    heroTitle: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ",
    heroDesc: "ਆਪਣਾ ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    emailPlaceholder: "ਆਪਣੀ ਈਮੇਲ ਦਰਜ ਕਰੋ",
    sendBtn: "ਰੀਸੈਟ ਲਿੰਕ ਭੇਜੋ",
    sending: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
    success: "ਜੇ ਤੁਹਾਡੀ ਈਮੇਲ ਰਜਿਸਟਰ ਹੈ, ਤੁਹਾਨੂੰ ਪਾਸਵਰਡ ਰੀਸੈਟ ਲਿੰਕ ਮਿਲ ਜਾਵੇਗਾ।",
    error: "ਰੀਸੈਟ ਲਿੰਕ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ।",
  },
};

export default forgotPasswordTranslations;
